import configurationProvider from "@/Core/configurationProvider";
import { ModuleManager } from "@module-system";
/**
 * @type {import('@module-system').IModule}
 */
var module = {
  name: "Demo / Test Pages",
  version: "1.0.0",
  register() {
    const demoActive = configurationProvider.getBoolRef("DEMO_ACTIVE", false);
    const testActive = configurationProvider.getBoolRef("TEST_ACTIVE", false);

    if (testActive.value) {
      ModuleManager.addRoute({
        path: "/test",
        name: "Development test page test",
        component: () => import("./Components/TestPage.vue"),
        beforeEnter: (to, from, next) => {
          if (!testActive.value) {
            next(false);
            return;
          }
          next();
        },
        props: true,
      });

      ModuleManager.addRoute({
        path: "/t",
        name: "Development test page t",
        component: () => import("./Components/TestPage.vue"),
        beforeEnter: (to, from, next) => {
          if (!testActive.value) {
            next(false);
            return;
          }
          next();
        },
        props: true,
      });
    }

    if (demoActive.value) {
      ModuleManager.addRoute({
        path: "/",
        name: "Demo Call Page",
        component: () => import("./Components/DemoPage.vue"),
        beforeEnter: (to, from, next) => {
          if (!demoActive.value) {
            next(false);
            return;
          }
          next();
        },
        props: true,
      });
    }
  },
};
export default module;
